import { AvatarHandler } from "./avatar-handler";
import { avatarForm } from "./avatar-form";

export class UserAvatarSetup {
    public static init(): void {
        const avatarModal = avatarForm.getModal();
        if (!(avatarModal instanceof HTMLElement)) return;

        const userId = avatarForm.getModalUserId(avatarModal);
        if (!userId) return;

        const handler = new AvatarHandler(userId, avatarModal);
        handler.init();
    }
}
